export default __webpack_public_path__ + "static/ImmigrationAims_Logo_Dark_transparent-a77852110c3b759e2eb4879f767a5682.png";